var map = {
	"./pages/Authentication/authentication.module": [
		"./src/default/pages/Authentication/authentication.module.ts",
		"common",
		"pages-Authentication-authentication-module"
	],
	"./pages/account/account.module": [
		"./src/default/pages/account/account.module.ts",
		"default~pages-account-account-module~pages-checkout-checkout-module",
		"common",
		"pages-account-account-module"
	],
	"./pages/cart/cart.module": [
		"./src/default/pages/cart/cart.module.ts",
		"default~pages-cart-cart-module~pages-products-products-module",
		"common",
		"pages-cart-cart-module"
	],
	"./pages/categoria/categoria.module": [
		"./src/default/pages/categoria/categoria.module.ts",
		"pages-categoria-categoria-module"
	],
	"./pages/checkout/checkout.module": [
		"./src/default/pages/checkout/checkout.module.ts",
		"default~pages-account-account-module~pages-checkout-checkout-module",
		"common",
		"pages-checkout-checkout-module"
	],
	"./pages/contact/contact.module": [
		"./src/default/pages/contact/contact.module.ts",
		"common",
		"pages-contact-contact-module"
	],
	"./pages/home/home.module": [
		"./src/default/pages/home/home.module.ts",
		"pages-home-home-module"
	],
	"./pages/products/products.module": [
		"./src/default/pages/products/products.module.ts",
		"default~pages-cart-cart-module~pages-products-products-module",
		"common",
		"pages-products-products-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;